export const P00032SensContactEnum = [
  { ref: 0, label: 'P00032.senscontact.0' },
  { ref: 1, label: 'P00032.senscontact.1' },
  { ref: 99, label: 'generic.byprocedure' },
];
